import React from 'react'
import View from './view'

type Props = {
  onClose?: () => void
}

const Sidenav = ({onClose}: Props) => {
  return <View onClose={onClose} />
}

export default Sidenav
